import React, { useState, useEffect, useContext } from 'react';
import { getMobileOS } from 'web-store-modules/packages/obsess-device-detector';
import './SharePanelSocialIcon.css'
import { isMobileDevice } from '../../../utils/DeviceDetector';
import { AppContext } from '../../../AppContext';
import { MailIconClicked, ShareOptionClicked } from '../../../utils/Analytics';
const isMobile = isMobileDevice();

const SharePanelSocialIcon = ({ redirectUrl, name, textAbove, targetSelf, iconSrc, primaryColor, showScreenshot, setShowScreenshot }) => {
    const [showTextAbove, setShowTextAbove] = useState(false);
    const appContext = useContext(AppContext);
    useEffect(() => {
        if (showTextAbove) {
            setTimeout(() => { setShowTextAbove(false) }, 2600);
        }
    }, [showTextAbove])

    const shareClicked = () => {
        if (name === 'Mail') {
            MailIconClicked();
        }
        if (textAbove) {
            setShowTextAbove(true)
        }

        if (['Mail', 'Messages'].includes(name)) {
            window.location.href = redirectUrl;
        } else if (name === 'CopyLink') {
            ShareOptionClicked('Link copied clicked', 'Link copied' );

            // Copy the link in textField
            const textField = document.createElement('textarea');
            textField.innerText = redirectUrl;
            document.body.appendChild(textField);
            textField.readOnly = true;  // Prevent iOS chrome from opening up keyboard

            const range = document.createRange();
            range.selectNode(textField);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            document.execCommand('copy');
            selection.removeAllRanges();
            textField.remove();
        } else if (name === 'Instagram') {
            ShareOptionClicked(`${name} icon clicked`,`${name} icon` );
            setShowScreenshot(!showScreenshot)
        } else {
            // For Linkedin, Twitter, Facebook only
            ShareOptionClicked(`${name} icon clicked`, `${name} icon`,);
            window.open(redirectUrl, targetSelf ? '_self' : '_blank');
        }
    }

    return (
        <div onClick={shareClicked}>
            { textAbove && <span id='_event' className='share-text-above' style={{ opacity: showTextAbove ? 1 : 0 }}>{textAbove}</span> }
            <div id='_event' className='icon-bg'>
                <img id='_event' style={{ width: '3em' }} src={iconSrc} />
            </div>
        </div>
    )
}

export default SharePanelSocialIcon